import { http } from 'services';

// ## Instance - List Sources
// curl "http://192.168.0.20:3000/instance/sources"
export function getSources(cbSuccess, cbError) {
  http.get(
    'instance/sources',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Get Source by ID
// curl "http://192.168.0.20:3000/instance/sources/2"
export function getSourceDetails(sourceID, cbSuccess, cbError) {
  http.get(
    `instance/sources/${sourceID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Activate Source
// curl -X "POST" "http://192.168.0.20:3000/instance/sources/2/activate" \
export function activateSource(sourceID, cbSuccess, cbError) {
  http.post(
    `instance/sources/${sourceID}/activate`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// ## Instance - Deactivate Source
// curl -X "POST" "http://192.168.0.20:3000/instance/sources/2/activate" \
export function deactivateSource(sourceID, cbSuccess, cbError) {
  http.post(
    `instance/sources/${sourceID}/deactivate`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-instance/api-instance-sources.js